import React from 'react'
import styled from 'styled-components'

const ErrorPage = () => {
  return <Container>Not Found Page</Container>
}

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default ErrorPage
